export default __webpack_public_path__ + "static/media/video-icon.ff498e42.webp";